const timestampMiddleware = (store: any) => (next: any) => (action: any) => {
  action.timestamp = new Date().getTime();
  next(action);
};

export default timestampMiddleware;
